"use client";

import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";
import type { GameAPI } from "@rosette/ts/src/business/api/GameAPI.js";
import { WebGameAPI } from "@rosette/web_utils/src/WebGameAPI.js";
import { useEnv } from "@/components/env/EnvContext.js";

const GameAPIContext = createContext<GameAPI | null>(null);

export function useGameAPI(): GameAPI {
    const api = useContext(GameAPIContext);
    if (!api)
        throw new Error("useGameAPI must be used within GameAPIProvider");

    return api;
}

interface GameAPIProviderProps {
    children: ReactNode;
}

export function GameAPIProvider({ children }: GameAPIProviderProps) {
    const env = useEnv();

    const gameAPI = useMemo(() => {
        return new WebGameAPI(env.gameServerUrl);
    }, [env.gameServerUrl]);

    return (
        <GameAPIContext.Provider value={gameAPI}>
            {children}
        </GameAPIContext.Provider>
    );
}
